import { useState, useEffect } from 'react'
import { ajax } from '@src/utils/ajax'

import { Category } from '../types'

const usePartnersData = () => {
  const [data, setData] = useState<Array<Category>>([])
  const [isFetching, setIsFetching] = useState(true)

  const fetchData = () => {
    setIsFetching(true)
    ajax
      .get<{ data: Array<Category> }>('/partners/get-partners')
      .then(response => {
        setData(response.data.data)
      })
      .finally(() => {
        setIsFetching(false)
      })
  }

  useEffect(fetchData, [])

  return {
    data,
    isFetching
  }
}

export default usePartnersData
